import Flickity from 'flickity-imagesloaded'
import imagesLoaded from 'imagesloaded'

Flickity.prototype.imagesLoaded = function() {
  if(!this.options.imagesLoaded) return;

  var _this = this;

  function onImagesLoadedProgress(instance, image) {
    var cell = _this.getParentCell(image.img);
    _this.cellSizeChange(cell && cell.element);
    if(!_this.options.freeScroll) _this.positionSliderAtSelected();
    _this.dispatchEvent('imagesLoadedProgress', null, [image.img, cell.element]);
  }
  imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
}

export default Flickity


// WEBPACK FOOTER //
// ./src/flickity.js